function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.29 26.8182V35.6667C11.29 36.219 11.7378 36.6667 12.29 36.6667H20.1385C20.6908 36.6667 21.1385 36.219 21.1385 35.6667V22.3792C21.1385 22.3204 21.1862 22.2727 21.245 22.2727H24.5476C29.7776 22.2727 34.0173 18.033 34.0173 12.803C34.0173 7.57306 29.7776 3.33333 24.5476 3.33333H11.4779C11.3741 3.33333 11.29 3.41742 11.29 3.52116V15.5297C14.8512 13.3501 19.1706 11.8135 20.76 11.6667L20.0025 10.1516L26.0631 10.9091L21.8964 15.0758L21.2603 13.3088C16.8175 15.3152 13.4419 17.4661 11.29 19.4675V26.8181C11.2901 26.8182 11.2902 26.8182 11.2903 26.8182C11.2902 26.8182 11.2901 26.8182 11.29 26.8182Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2901 26.8182C7.49302 25.6316 7.71038 22.8095 11.2901 19.5629V26.8182Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.5,
  y1: 20,
  x2: 11.5,
  y2: 25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#333646"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#333646",
  stopOpacity: 0
})));

var SvgLogoWhite = function SvgLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-white.545493ae.svg";
export { ForwardRef as ReactComponent };